/* =========================================
SCRIPT FOR THE ORDER/TABLE BEHAVIOR
============================================*/
const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiM2NhZmI5NDdlYjkzMjQ0ZmQxZjA1MDg5NGQ0NzEyZTNiYzNlZDE4N2M3ZjhkYTA0YmNkMzJhMzEzZjJmZmU1NzhhNTIzZTBiNGU4MWRjZjQiLCJpYXQiOjE2OTk2OTA1MjAsIm5iZiI6MTY5OTY5MDUyMCwiZXhwIjoxNzMxMzEyOTIwLCJzdWIiOiI5Iiwic2NvcGVzIjpbXX0.FMIDu65RPTIwbJk8_hINbMO1K3_-6AgYXzvOsbUpN1Xi8huOwkyY2iaFHXBPJS8n58n8rGsulVFevMxN96ofw5zjgljYfATEPHtBBVy9jbentW4xWhSt63S08M0FLoC2fwW4yfwJkp9kvDbe9YngNRtK1wZI8bteEZsgsD5iEqixN7tDsOSlVrGMsPgLbgbhJ4s7NT1m0qIXM1Mf-WBJUciol8IavzdrmbY3geGVBOGaOMXWykCa_pTIR37QVkx-Xx7R4x7RDIcsFyJ1vNjk4A4jiFRFGYFs95WwfP8PRg0e5le715p6NpGNxWeoPifP4F-P8jnqA9sRlVAavUhP3K5mq2LDLQfdAE7Q6H4m590rjgSNxHOJPuO_kML_s2dJUbsKNSneeyiNvQGLCNG4-75EzHTAg1gRs7YqGf86AMOfrXwqfo9zoKkWzS7Xi2JDBJrOCJNT5FyKkhXE9Je3WmAajNjAz3CglgjN3P3RQiBCIF-MWkJ0NDKomrw1kdXIp9HwzDT_7vIcTBwekYZmeQvQxpzz3m2qo8KyNRTd1ctFBuqECuuk58ZEfegEJibU83ZNypBqo0rE3OONScfbFIsOmXmwUl9gceln5dgf7nNs9ZEVScvAKp7mZiyvKFTBSoKA1HTgr7jXT6gZlQgM0Gz1w7M3CFuv4TzPLTPuUg8";
//const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiN2EyNmE0OTkyZjQ3NzNkMzRhNDBjMGFjYTY4NmU5MWE3MTZhNTZjY2Q5MGQ0NzQxZmQ1MWFlNGQ2M2ExYWE4MmFmYmFhN2Q4YTc4NTM2YzMiLCJpYXQiOjE2NjUzNzM5NzAsIm5iZiI6MTY2NTM3Mzk3MCwiZXhwIjoxNjk2OTA5OTcwLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.jysL2UVAKPnlPRrZH3dfv3CJ5oU7m8h4dUC_WVwfuQLhkVtDIoTWwVFJJroGlcUCbIsiSeBavSrywF51n2TAGmX0t8EYjQ7lK8q4m5YZi-FgBrebiHLgekadEPnXWbuhf-DxVTswGaG9s535Sx9QcnF1sUNS0ypvUtBEk2WwTU0P0Opa7XAFJ0OO9Ouo-7ZgqFb_UThJuYaiXd3LVCWJHrPkE1pLlXlKUKfARPVFba_lscm_gUd4x7320Z6zKUF4vJG3zeHkLKb1Z93ENrelsYSzFM4kwZOikUyPneGM2q9dvJAt5eDNbWJkryRZaz2ZKyRUqc0keivC2wOODpaWd4XRdBnu2sf9_JoTpdFh5nkAJ1sXNREjEhiooWTLz1juaCvBvoqgi0pfjCAfGERrqoQcLNVsLxo1i-foVH_AEQvdhpuuc0XHYUSjVDvKWoBxl-Pneua102ANUbXvXgdqutpUdlqPw6eFe4KOwFBhq34ZnWE0BRYUgXoK3chbe53hv74QI4NtxRU-hc-kGP74Oy1gmhBgQdw3bq1CZL-mUIIdiMZik8dB-t6alSWQgVvcQkUuNrsfOT20tOyNMakuzfnO0O-XfLLEQ2s9NG1O8z-vAB4mtEffTWCTf7oczsxlrdaDMjyTYtQTIBQQjMpMLieVgL2wJq8whGnIPuAjPwc";
//const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiODBmN2MzZTI4OGMzOTZlOGRmNjJkMTM0Y2U2NmY2NWMzMGQ1YWZhNjZlZGJlMGEyZjY2ZTA5ODZhYWU1MDEyODQwMWQyYThmY2MzOGIzZDIiLCJpYXQiOjE2OTY2MDI4MDYsIm5iZiI6MTY5NjYwMjgwNiwiZXhwIjoxNzI4MjI1MjA2LCJzdWIiOiIxMiIsInNjb3BlcyI6W119.6AwER_NQTfWtaub6tSoJYeEq8WPeBul2mraPSLnnSJrNbSDQVroFq5HHyfD_WrH34E33SZpb_5U3_I4zaqxULA0dyqjywVBM8LqgU2z_A11djRm7_0cp_CpuU4-9B_Xvn1BHBF3Rb7GBlBa7jopUkwAo9mzrdbrfwbLYXKUeHGnBBcMWPJ_62g7KrIWeBg2hUnwPY3Eyh4OPLxxgixzi1Qzd0xeXfQ6PyMTMBKLPBkxDPbWXntNQ0bmmZOTbyxwVv9UCLOc6DQH3KcYhOXMXBBbljaryKe9ePX09Sa-FjTNKxLwaUhYyOcNZNhLSxa8hyN6nWeAlbLYXCZ8mvrlhNOJUrqxf-Ecth6nxZDpTUk3C0DYhGIUqUVfgsJwRZ82exCkZ4CfNglPU5SJZ5kW51k4Y3TV915M0twhIAf4N33vVLg0KK5YxEDq_hHDusDUy1jvQFC1MjL9c64bV3059o4K_6T8SiFPhJ0dBBtVhwRySzO0XT0YmZEZ2zeorU-LWJrlM1QlmUAnabRjxYohbBx1MgXOVOfzPEFZRa4mL8O83eYd6Ox2_d_OAJhRqPNrr8SaWpeUc9XBRPhLGu4xAhnlkigZgL3gv8mvNRvUyCa3xigiGhSLu6wgj7bdS2InpTAYIMcMn--LQTW1alDJYvkoNugU8jlTYkAe6X2UmhNg";

var email, phone, otp, otp_hash, pay_type, total_sum, upfront_years;
var aircon_url = "https://jobmaster.prismplushome.sg";
//var aircon_url = "https://ae03-2405-800-9031-7bac-4575-bf33-3ab4-22bb.ngrok.io";
var button = document.querySelector('#submit-button');
var timeleft = 90;
var extra_unit_price = 22;
var allowed_systems = 4;
var utm_params = getUTMParams();
var ua_details = getUADetails();
var retail = reatilParams();
var payment_token =  null;
var deviceData =  null;
console.log('prismcarev2');
console.log('uadetails:'+ua_details.userAgent+' - '+ua_details.deviceType+' - '+ua_details.OS+' - '+ua_details.browser+' - '+ua_details.resolution);
$body = jQuery("body");

jQuery( ".system_qty-input" ).change(function() {

  //set value of total of all rows
   hideError();
   total_sum = price_calculation();
   $('#total_price').text('$'+total_sum);
});
pay_type_update();
jQuery( "input[name='pay_type']" ).click(function() {
   pay_type_update();
});

jQuery( "#upfront_years" ).change(function() {
   pay_type_update();
});

jQuery( ".qty-increase" ).click(function() {
  
  var system = $(this).attr('data-system');
  cObj = $('#sys'+system+'-qty');
  var sys_qty = cObj.val();
  if (parseInt(sys_qty) >= allowed_systems){
    showError("Maximum of " + allowed_systems + " systems is allowed per subscription.")
    return false;
  }else{
    hideError();
  }
  cObj.val(parseInt(sys_qty) +  1);
  total_sum = price_calculation();
  
});
jQuery( ".qty-decrease" ).click(function() {
  hideError();
  var system = $(this).attr('data-system');
  cObj = $('#sys'+system+'-qty');
  var sys_qty = cObj.val();
  if (parseInt(sys_qty) == 0){
    return false;
  }
  cObj.val(parseInt(sys_qty) -  1);
  total_sum = price_calculation();
});
function pay_type_update(){
   pay_type = jQuery("input[name='pay_type']:checked").val();
   jQuery("input[name='pay_type']:checked").addClass('active');
   total_sum = price_calculation();

  if (pay_type =='upfront'){
    upfront_years = parseInt(jQuery("#upfront_years").val());
     $('.pay-type').text(upfront_years + ' years upfront');
     $('.pay-type-small').text(upfront_years + ' years upfront');
     $('.yearly-disclaimer .yearly-qty').text(upfront_years);
     $(".pay-option .pay-item").removeClass('active');
     $(".pay-option .pay-upfront").parent().addClass('active');
     if(upfront_years != '8'){
        $(".yearly-disclaimer").addClass('active');
      }else{
       $(".yearly-disclaimer").removeClass('active');
      }
    
   }else if (pay_type =='yearly'){
     $('.pay-type').text('Yearly');
     $('.pay-type-small').text('yearly');
     $(".pay-option .pay-item").removeClass('active');
     $(".pay-option .pay-yearly").parent().addClass('active');
     $(".yearly-disclaimer").removeClass('active');
   }else if(pay_type =='quarterly'){
      $('.pay-type').text('Quarterly');
      $('.pay-type-small').text('quarterly');
       $(".pay-option .pay-item").removeClass('active');
       $(".pay-option .pay-qtrly").parent().addClass('active');
     $(".yearly-disclaimer").removeClass('active');
   }else{
     upfront_years = parseInt(jQuery("#upfront_years").val());
     $('.pay-type').text(upfront_years + ' years upfront');
      $('.pay-type-small').text(upfront_years + ' years upfront');
      $('.yearly-disclaimer .yearly-qty').text(upfront_years);
      $(".pay-option .pay-item").removeClass('active');
      $(".pay-option .pay-upfront").parent().parent().addClass('active');
      if(upfront_years != '8'){
        $(".yearly-disclaimer").addClass('active');
      }else{
       $(".yearly-disclaimer").removeClass('active');
      }
      
      
   }
}
function price_calculation(){
  var totalunit = 0;
  var total_systems = 0;
  jQuery( ".system_qty-input" ).each(function() {
    var sysqty = this.value;
    var sysval = jQuery(this).attr('data-price')
    totalunit += parseInt(sysqty)*parseInt(sysval);
    total_systems +=parseInt(sysqty);
  });
  console.log(total_systems);
  if(total_systems > allowed_systems){
    showError("Maximum of " + allowed_systems + " systems is allowed per subscription.")
    return false;
  }
  var total_sum = 0;
  if (totalunit == 1){
    total_sum = 50;
  }else if(totalunit == 2){
    total_sum = 60
  }else if(totalunit == 3){
    total_sum = 75
  }else if(totalunit == 4){
    total_sum = 90
  }else if(totalunit > 0){
    total_sum = 90 + ((totalunit -  4) * extra_unit_price)
  }
  pay_type = jQuery("input[name='pay_type']:checked").val();
  
  if(pay_type == 'upfront'){
    upfront_years = parseInt(jQuery("#upfront_years").val());
    jQuery('.units').text(totalunit+' units x ' + upfront_years + ' years =  $' + total_sum + ' x ' + (upfront_years * 4) + ' quarters');
    total_sum = total_sum * 4 * upfront_years;
  }else if(pay_type == 'yearly'){
    jQuery('.units').text(totalunit+' units yearly =  $' + total_sum + ' x 4 quarters');
    total_sum = total_sum * 4;
  }else{
    jQuery('.units').text(totalunit+' units quarterly');
  }
  jQuery('.total-purchase').text('$'+total_sum);
  
  return total_sum ;
}

function cart_summary(){
   var cart_html = "";
  jQuery( ".system_qty-input" ).each(function() {
    var sysqty = this.value;
    var pay_text = pay_type;
    if(pay_type == 'upfront'){
      pay_text = upfront_years + ' years upfront';
    }
    if (parseInt(sysqty) > 0){
      var sysval = jQuery(this).attr('data-price');
      cart_html +='<div class="system-item flex-wrap justify-between"><div class="selected-system"><p class="sys-type">System '+sysval+' - <span class="pay-type">pay '+pay_text+'</span></p><p>General servicing package for systems with '+sysval+' indoor units to one main compressor</p></div><div class="system-quantity"><span class="mobile-show">Qty:</span><p class="qty">'+sysqty+'</p></div></div>'
    }
  });
  jQuery(".cart-items").html(cart_html);
  
  if(retail){
    jQuery("#staffName").val(getStaffName());
     jQuery("#staffName").show();
  }else{
    jQuery("#staffName").val(getStaffName());
     jQuery("#staffName").show();
  }
  
}

/* =========================================
SCRIPT FOR THE MULTISTEP FORM
============================================*/
var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab

function showTab(n) {
  console.log('j1');
  // This function will display the specified tab of the form...
  var x = document.getElementsByClassName("tab");
  x[n].style.display = "block";
  //... and fix the Previous/Next buttons:
  
  //... and run a function that will display the correct step indicator:
  fixStepIndicator(n)
}

function showError(message){
   let error =  '<strong>Error!</strong> ' + message;
   $('#error_tag').html(error)
   $('#error_tag').css('visibility', 'visible');
}

function hideError(){
   $('#error_tag').html('')
   $('#error_tag').css('visibility', 'hidden');
}

function showValidationError(cObj, message){
  $(cObj).next().remove('span');
  cObj.addClass('invalid');
  cObj.after('<span class="validation error">' + message + '</span>')
}

function removeValidationError(cObj){
  $(cObj).removeClass('invalid');
  $(cObj).next().remove('span');
}

function nextPrev(n) {
  console.log(currentTab);
  console.log("nextperv")
  // This function will figure out which tab to display
  var x = document.getElementsByClassName("tab");
  // Exit the function if any field in the current tab is invalid:
  if (n == 1 && !validateForm()) return false;
  // Hide the current tab:
  if(currentTab == 0){
    sendusertoOTP(n, switchTab);
    // email = $("#email").val().trim();
     //phone = $("#phone").val().trim();
     //validateOTP(n+1, switchTab);
    //$(".initialsteps").removeClass('active');
  }else if(currentTab == 1){
    validateOTP(n, switchTab);
    //switchTab(n);
    //$(".initialsteps").removeClass('active');
  }else if(currentTab == 2){
    hideError()
    var total_systems = 0;
    jQuery( ".system_qty-input" ).each(function() {
      var sysqty = this.value;
      total_systems +=parseInt(sysqty);
    });
    
    if (total_systems == 0){
      showError("Please select at least one system.")
      return false;
    }
    
    if (total_systems <= allowed_systems){
      generate_paypalform(payment_token);
      cart_summary();
      switchTab(n);
    }else{
      showError("Maximum of " + allowed_systems + " systems is allowed per subscription.")
    }
   // $(".initialsteps").removeClass('active');
  }
 
}

function resetTab(){
  if (confirm('Are you sure you want to go to pervious step?')) {
    var x = document.getElementsByClassName("tab");
    x[currentTab].style.display = "none";
    currentTab=0;
    showTab(currentTab);
    $("#otp_code").val('')
  }
 
}

function previousTab(){
  if (confirm('Are you sure you want to go to pervious step?')) {
    var x = document.getElementsByClassName("tab");
    x[currentTab].style.display = "none";
    currentTab--;
    showTab(currentTab);
  }
 
}

function switchTab(n , form_status = true){
  var x = document.getElementsByClassName("tab");
   x[currentTab].style.display = "none";
  // Increase or decrease the current tab by 1:
  currentTab = currentTab + n;
  // if you have reached the end of the form...
  if (currentTab >= x.length) {
    // ... the form gets submitted:
    //*submit otp and display the order information
    //document.getElementById("initialsearch").submit();
    if (form_status == true){
      $(".subscription_success").addClass('active');
    }else{
      $(".subscription_failure").addClass('active');
    }
    $(".main-form").addClass('submitted');
    return false;
  }
  // Otherwise, display the correct tab:
  showTab(currentTab);
  
}
function validateForm() {
  // This function deals with validation of the form fields
  var x, y, i, valid = true;
  x = document.getElementsByClassName("tab");
  y = x[currentTab].getElementsByTagName("input");
  // A loop that checks every input field in the current tab:
  for (i = 0; i < y.length; i++) {
    // If a field is empty...
    if (y[i].value == "") {
      // add an "invalid" class to the field:
      y[i].className += " invalid";
      // and set the current valid status to false
      valid = false;
    }
  }
  // If the valid status is true, mark the step as finished and valid:
  if (valid) {
    document.getElementsByClassName("step")[currentTab].className += " finish";
  }
  return valid; // return the valid status
}

function fixStepIndicator(n) {
  // This function removes the "active" class of all steps...
  var i, x = document.getElementsByClassName("step");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  //... and adds the "active" class on the current step:
  x[n].className += " active";
}
function clickNext(e){
  e.preventDefault();
  $( "#nextBtn" ).click();

}
function clickBack(){
  $( "#prevBtn" ).click();

}
/* ==========================
OTP 
============================*/
function sendusertoOTP(n, callBack){
   
  
   email = $("#email").val().trim();
   phone = $("#phone").val().trim();
   $.ajax({
        type: 'POST',
        url: aircon_url + '/api/braintree/sendotp',
        data: { email, phone, utm_params, ua_details},
        success: function (data, status, xhr){
            if (data.status == true){
                hideError(message);
                otp_hash = data.data.otp_token;
                $(".phonenum").text(getMaskedNumber(phone))
                callBack(n)
                resendTimer()
                //$("#show_email").val(email)
               
            }else {
              var message="";
              if (data.errors.email){
                 showValidationError($("#email"), data.errors.email.toString())
              }
              if (data.errors.phone){
                 showValidationError($("#phone"), data.errors.phone.toString())
              }
              //showError(message)
            }
        },
        beforeSend: function(xhr, settings) { 
          xhr.setRequestHeader('Authorization','Bearer ' + tokenString );  
          $body.addClass("loading");   }, //set tokenString before send
        complete: function(){
           $body.removeClass("loading"); 
        },
    });
}

function validateOTP(n, callBack){
   otp_code = $("#otp_code").val().trim();
   if (!otp_code || !otp_hash) {
     return false;
   }
   $.ajax({
        type: 'POST',
        url: aircon_url + '/api/braintree/validateotp',
        data: { otp_hash, otp_code, email},
        success: function (data, status, xhr){
            
            if (data.status == true){
                payment_token = data.data.payment_token;
                $(".initialsteps").removeClass('active');
                callBack(n)
            }else {
              if (data.errors){
                   showValidationError($("#otp_code"), data.errors.toString())
              }
            }
        },
        beforeSend: function(xhr, settings) { 
          xhr.setRequestHeader('Authorization','Bearer ' + tokenString );  
          $body.addClass("loading");   }, //set tokenString before send
        complete: function(){
           $body.removeClass("loading"); 
        },
  });
}

function generate_paypalform(payment_token) {
  if (!payment_token) {
    return false;
  }
  
  braintree.dropin.create({
      authorization: payment_token,
      selector: '#dropin-container',
      dataCollector: true
  }).then( function (instance) {
      button.addEventListener('click', function () {
          hideError()
          let system_1 = parseInt($('#sys1-qty').val());
          let system_2 = parseInt($('#sys2-qty').val());
          let system_3 = parseInt($('#sys3-qty').val());
          let system_4 = parseInt($('#sys4-qty').val());
          var total_qty = system_1 + system_2 + system_3 + system_4;
          if (total_qty < 1) {
              showError("Please select at least one system.")
              return false;
          } else if (total_qty > 4) { 
              showError("Maximum of " + allowed_systems + " systems is allowed per subscription.")
              return false;
          }
          instance.requestPaymentMethod(function (err, payload) {
             checkout({system_1, system_2, system_3, system_4}, payload, instance)
          })
      });
  })

   
  
}

 function checkout( systems, payload, instance ) {
   
    if (!payload) {
        return false;
    }
    sub_pay_type = pay_type;
    if (pay_type == "yearly") { // set yearly 
       upfront_years = 1
       sub_pay_type = 'upfront';
    }
    var staffname = jQuery("#staffName").val();
    let params = { 'paymentMethodNonce' : payload.nonce, 'deviceData' : payload.deviceData, email, phone, otp_hash, otp_code, systems, 
                  pay_type : sub_pay_type, utm_params, ua_details, staffname, retail, upfront_years, 'total_price': total_sum }
    // const sys = ["system 1", "system 2", "system 3", "system 4"];
   
    $.ajax({
        type: 'POST',
        url: aircon_url + '/api/braintree/checkout_old',
        data: params,
        beforeSend: function(xhr, settings) { 
          xhr.setRequestHeader('Authorization','Bearer ' + tokenString );  
          $body.addClass("loading");   }, //set tokenString before send
        complete: function(){
           $body.removeClass("loading"); 
        },
    }).done(function(result) {
        console.log(result)
        if (result.status != true){     
          instance.clearSelectedPaymentMethod(); 
          let error =  '<strong>Payment failed!</strong> Please try again.';
           $('#payment_error').html(error)
           $('#payment_error').css('visibility', 'visible');
          return;
        }   
        //return;
        // Tear down the Drop-in UI
        instance.teardown(function (teardownErr) {
            if (teardownErr) {
                console.error('Could not tear down Drop-in UI!');
            } else { 
                $('#submit-button').remove();
              if (result.status == true){                
                 let myIframe = document.getElementById("myIframe");
                 // let endpoint = "https://airtable.com/embed/shr9QItu7foiyHi2B?backgroundColor=green";
                 let endpoint = "https://airtable.com/embed/shr5Rv8D7sEguIG6t?backgroundColor=green";
                 let fullURL = endpoint+"&prefill_SubscriptionID="+result.data.subscription_id+"&hide_SubscriptionID=true&prefill_Email Address="+email+"&hide_Email Address=true&prefill_Contact Number="+phone+"&hide_Contact Number=true";
                 // console.log(fullURL);
                 myIframe.src = fullURL;
                 $("#subsription_ref_id").html(result.data.subscription_id);
                $(".user-email").text(email);
                 switchTab(1)
              }else{
                 switchTab(1, false)
              }
               
            }
        });
    });
}

function resendTimer(){
   var html = 'Resend (<span id="countdowntimer">' + timeleft + '</span>)';
   document.getElementById("resend_otp").innerHTML = html;
   var downloadTimer = setInterval(function(){
    timeleft--;
    document.getElementById("countdowntimer").textContent = timeleft;
      if(timeleft <= 0){
          clearInterval(downloadTimer);
          var html = '<a class href="#" onclick="resendOTP()">Resend</a>';
           document.getElementById("resend_otp").innerHTML = html;
      }
    },1000);
}

function resendOTP() {
  $.ajax({
        type: 'POST',
        url: aircon_url + '/api/braintree/sendotp',
        data: { email, phone},
        success: function (data, status, xhr){
            if (data.status == true){
                hideError();
                otp_hash = data.data.otp_token;
                document.getElementById("resend_otp").innerHTML = "";
                timeleft = 90;
                resendTimer()
            }
        },
        beforeSend: function(xhr, settings) { 
          xhr.setRequestHeader('Authorization','Bearer ' + tokenString );  
          $body.addClass("loading");   }, //set tokenString before send
        complete: function(){
           $body.removeClass("loading"); 
        },
    });
}


function getUTMParams(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    var utm_source = urlParams.get('utm_source')
 
    // shirt
    
    var utm_medium = urlParams.get('utm_medium')
    // blue
    var utm_campaign = urlParams.get('utm_campaign')
    var utm_term = urlParams.get('utm_term')
    var utm_content = urlParams.get('utm_content');

    return  utm_params = {utm_source, utm_medium, utm_campaign, utm_term, utm_content};
}

function getUADetails(){
  let userAgent = navigator.userAgent;
  let ua = detect.parse(navigator.userAgent);
  // let browserName  = `Browser Name: ${ua.browser.name}`;
  let deviceType = ua.device.type;
  let OS = ua.os.name;

  let browser = (function (agent) {
   switch (true) {
    case agent.indexOf("edge") > -1: return "edge";
    case agent.indexOf("edg") > -1: return "chromium based edge (dev or canary)";
    case agent.indexOf("opr") > -1 && !!window.opr: return "opera";
    case agent.indexOf("chrome") > -1 && !!window.chrome: return "chrome";
    case agent.indexOf("trident") > -1: return "ie";
    case agent.indexOf("firefox") > -1: return "firefox";
    case agent.indexOf("safari") > -1: return "safari";
    default: return "other";
  }
  })(window.navigator.userAgent.toLowerCase());

  let resolution = window.screen.availHeight +" x "+ window.screen.availWidth;
  
  return  uadetails = {userAgent, deviceType, OS, browser, resolution };
}

function reatilParams(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('retail')
}

function getStaffName(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('staff_name')
}

function isNumber(char) {
  return /^\d$/.test(char);
}

function getMaskedNumber (number){
    var endDigits = number.slice(-4);
    return endDigits.padStart(number.length, '*');
}